import { THEMES, DISPLAY_THEMES } from '../constants/Consts';

export const getDisplayTitle = (themeType: THEMES): string => {
  switch (themeType) {
    case THEMES.DISNEY:
      return DISPLAY_THEMES.DISNEY;
    case THEMES.MICRATCH:
      return DISPLAY_THEMES.MICRATCH;
    case THEMES.ROBLOX:
      return DISPLAY_THEMES.ROBLOX;
    default:
      return '';
  }
};